window.hlfFloatingCart = {
  cartImages: [], // Stores up to 2 image URLs
  previousItemsMap: new Map(), // Tracks quantities to detect added items

  init() {
    this.element = document.getElementById('hlf-floating-cart');
    this.thumbnailsContainer = document.getElementById('hlf-floating-cart-thumbnails');
    this.countElement = document.getElementById('hlf-floating-cart-count');
    
    if (!this.element) return;

    // Fetch initial cart silently to populate previousItemsMap
    this.fetchCart(true);

    let timeout;
    const handleUpdate = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.fetchCart(false);
      }, 50);
    };

    if (window.PUB_SUB_EVENTS && window.subscribe) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, handleUpdate);
    }
    
    document.addEventListener('cart:update', handleUpdate);
    document.addEventListener('cart:updated', handleUpdate);
    document.addEventListener('cart:refresh', handleUpdate);
  },

  async fetchCart(isInitial = false) {
    try {
      const cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
      const response = await fetch(cartUrl + '.js');
      const cart = await response.json();
      this.updateCartUI(cart, isInitial);
    } catch (error) {
      console.error('Error fetching cart data:', error);
    }
  },

  updateCartUI(cart, isInitial) {
    if (!this.element || !cart) return;

    if (cart.item_count === 0) {
      this.element.classList.remove('is-visible', 'is-expanded', 'is-item-added');
      this.thumbnailsContainer.innerHTML = '';
      this.cartImages = [];
      this.previousItemsMap.clear();
      return;
    }

    const wasVisible = this.element.classList.contains('is-visible');
    
    let addedItemUrl = null;
    let anyAdded = false;

    // Detect if any item was added (quantity increased)
    const currentItemsMap = new Map();
    cart.items.forEach(item => {
      currentItemsMap.set(item.id, item.quantity);
      
      if (!isInitial) {
        const prevQty = this.previousItemsMap.get(item.id) || 0;
        if (item.quantity > prevQty) {
          anyAdded = true;
          addedItemUrl = item.image || (item.featured_image ? item.featured_image.url : '');
        }
      }
    });

    // Fallback if we couldn't detect exactly which was added, but count went up
    const currentCount = parseInt(this.countElement.textContent) || 0;
    if (!isInitial && !anyAdded && cart.item_count > currentCount) {
      anyAdded = true;
    }
    if (anyAdded && !addedItemUrl && cart.items.length > 0) {
      // Fallback to latest item in array (in Dawn it's usually the most recently updated)
      const item = cart.items[0]; 
      addedItemUrl = item.image || (item.featured_image ? item.featured_image.url : '');
    }

    this.previousItemsMap = currentItemsMap;

    // Update count text
    this.countElement.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'Item' : 'Items'}`;

    if (isInitial) {
      // Setup initial visual state without animating DOM
      if (cart.item_count > 0) {
        this.cartImages = cart.items.slice(0, 2).map(item => item.image || (item.featured_image ? item.featured_image.url : ''));
        this.element.classList.add('is-visible', 'is-expanded');
      }
      return;
    }

    if (anyAdded && addedItemUrl) {
      // Update our stack: push new item to front
      this.cartImages.unshift(addedItemUrl);
      if (this.cartImages.length > 2) {
        this.cartImages = this.cartImages.slice(0, 2);
      }

      this.renderThumbnails(true);

      if (!wasVisible) {
        this.element.classList.add('is-visible');
        // Let it expand after drop animation finishes (500ms)
        setTimeout(() => {
          this.element.classList.add('is-expanded');
        }, 500);
      } else {
        // Just in case it wasn't expanded
        this.element.classList.add('is-expanded');
      }
    } else {
      // Item removed or quantity decreased - re-sync normally without animation
      this.cartImages = cart.items.slice(0, 2).map(item => item.image || (item.featured_image ? item.featured_image.url : ''));
      this.renderThumbnails(false);
      
      if (!wasVisible) {
        this.element.classList.add('is-visible', 'is-expanded');
      }
    }
  },

  renderThumbnails(animate) {
    this.thumbnailsContainer.innerHTML = '';
    
    // Render back to front conceptually, but DOM order matters for z-index overlapping.
    // CSS handles z-index, so we just append.
    this.cartImages.forEach((imgUrl, index) => {
      if (!imgUrl) return;

      const thumb = document.createElement('div');
      thumb.className = `hlf-floating-cart__thumb ${index === 0 ? 'hlf-floating-cart__thumb--front' : 'hlf-floating-cart__thumb--back'}`;
      
      if (animate && index === 0) {
        thumb.classList.add('is-dropping');
      }
      if (animate && index === 1) {
        thumb.classList.add('is-transitioning');
      }
      
      const img = document.createElement('img');
      img.src = imgUrl;
      img.width = 40;
      img.height = 40;
      img.loading = 'lazy';
      
      thumb.appendChild(img);
      this.thumbnailsContainer.appendChild(thumb);
    });

    if (animate) {
      this.element.classList.add('is-item-added');
      setTimeout(() => {
        this.element.classList.remove('is-item-added');
        const thumbs = this.thumbnailsContainer.querySelectorAll('.hlf-floating-cart__thumb');
        thumbs.forEach(t => t.classList.remove('is-dropping', 'is-transitioning'));
      }, 500);
    }
  },

  openCart() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.open) {
      cartDrawer.open();
    } else {
      const cartIcon = document.querySelector('#cart-icon-bubble, [data-hlf-cart-trigger], .header__icon--cart');
      if (cartIcon) {
        cartIcon.click();
      } else {
        window.location.href = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
      }
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  window.hlfFloatingCart.init();
});
